module.exports = __webpack_public_path__ + "img/مربع.29815600.png";